import routes from "routes"
import { Platforms } from "utils/constants"
import { detectPlatformFromPath } from "utils/platform"

type Options = {
  username?: string
  submissionId?: string
  courseId?: string
}
export const getSkillProfileRoute = (options?: Options) => {
  const currentPlatform = detectPlatformFromPath()

  let baseRoute = routes.skillProfile.public

  switch (currentPlatform) {
    case Platforms.school:
      baseRoute = routes.skillProfile.asSchool
      break
    case Platforms.centerAdmin:
      baseRoute = routes.skillProfile.asCentre
      break
    case Platforms.recruiter:
      baseRoute = routes.skillProfile.asRecruiter
      break
  }

  const route = options?.username
    ? baseRoute.replace(":username", options.username)
    : baseRoute.replace(":username", "")

  const searchParams = new URLSearchParams(window.location.search)
  if (options?.submissionId) searchParams.set("id", options.submissionId)
  if (options?.courseId) searchParams.set("course", options.courseId)

  return searchParams.toString() ? `${route}?${searchParams.toString()}` : route
}
